

import { useQuery } from "@tanstack/react-query";
import type { StoreListResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseStoresQueryParams = {
  limit?: number;
  offset?: number;
  sellerId?: string;
};

function buildPath(params: UseStoresQueryParams) {
  const query = new URLSearchParams();
  if (params.limit !== undefined) {
    query.set("limit", String(params.limit));
  }
  if (params.offset !== undefined) {
    query.set("offset", String(params.offset));
  }
  if (params.sellerId) {
    query.set("sellerId", params.sellerId);
  }

  const queryString = query.toString();
  return queryString.length > 0
    ? `${endpoints.admin.stores}?${queryString}`
    : endpoints.admin.stores;
}

export function useStoresQuery(params: UseStoresQueryParams = {}) {
  const query = useQuery({
    queryKey: queryKeys.admin.stores(params),
    queryFn: () => apiJsonClient<StoreListResponse>(buildPath(params)),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
